import { type AxiosResponse } from 'axios'
import api from '../utils/api'

const getInstructorsBySectionIdApi = async (sectionId: string): Promise<AxiosResponse> => {
  return await api.get(`/api/enrollments/?section_id=${sectionId}`)
}

const getFacultyAndStaffByIdApi = async (userId: string, params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/users/${userId}`, { params })
}

const getAllStudentsApi = async (params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/users/', { params })
}

const getStudentsByTermEnrollmentApi = async (termId: string, params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/terms/${termId}/enrollments/`, { params })
}

const postStudentRoleByIdApi = async (userId: string, requestBody: Record<string, any>): Promise<AxiosResponse> => {
  return await api.post(`/api/users/${userId}/role/`, requestBody)
}

const deleteStudentRoleByIdAndRoleIdApi = async (userId: string, roleId: string, params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.delete(`/api/users/${userId}/role/${roleId}`, { params })
}

const getRoleApi = async (params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/roles/summary/', params)
}

const getTopBarDivisions = async (): Promise<AxiosResponse> => {
  return await api.get('/api/roles/divisions/')
}

const exportStudentsCSV = async (params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/users/export/?is_student=True', { params })
}

export const resetEnrollmentsByTermId = async (termId: string): Promise<AxiosResponse> => {
  return await api.delete(`/api/enrollments/terms/${termId}/reset/`)
}

export const resetInstructorsByTermId = async (termId: string): Promise<AxiosResponse> => {
  return await api.delete(`/api/terms/${termId}/reset/sections/instructors/`)
}

export default {
  getFacultyAndStaffByIdApi,
  getStudentsByTermEnrollmentApi,
  getInstructorsBySectionIdApi,
  postStudentRoleByIdApi,
  deleteStudentRoleByIdAndRoleIdApi,
  getAllStudentsApi,
  getRoleApi,
  exportStudentsCSV,
  getTopBarDivisions
}
